import { environment } from '@environments/environment'

export function aircraftScheduleUrl(externalId: string): string {
  return `${environment.origamiBaseUrl}/Origami/Custom__AircraftSchedule/View/${externalId}`
}

export function equipmentScheduleUrl(externalId: string): string {
  return `${environment.origamiBaseUrl}/Origami/Custom__EquipmentSchedule/View/${externalId}`
}
